gsap.registerPlugin(ScrollTrigger);

class InigmaAnim extends HTMLElement {
  constructor() {
    super();

    this.parent = this.querySelectorAll(".inigma_anim_section");
    this.panel = this.querySelectorAll(".anim_panel");
    this.topPanel = this.querySelector(".anima_panel_top");
    this.topContent = this.querySelector(".anima_panel_top .top_text");
    this.topImage = this.querySelector(".anima_panel_top .inigma_media");
    this.topBg = this.querySelector(".anima_panel_top .lottie_bg_top");

    this.bottomPanel = this.querySelector(".anima_panel_bottom");
    this.bottomImage = this.querySelector(".anima_panel_bottom .inigma_media");
    this.blockHeading = this.querySelector(
      ".anima_panel_bottom .inigma_block_heading"
    );
    this.blockText = this.querySelector(
      ".anima_panel_bottom .inigma_block_text"
    );
    this.blockBtn = this.querySelector(".anima_panel_bottom .ingima_block_btn");

    this.init();
  }

  init() {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.topPanel,
          scrub: 1,
          start: "top 150px",
          end: "+=400",
          pin: true,
          pinSpacing: true,
        },
      })
      .to(this.topContent, { opacity: 0, scale: 0, ease: "none" }, 0)
      .to(this.topImage, {
        rotate: -27,
        translateY: "230%",
        opacity: 0.5,
        ease: "none",
      })
      .to(this.topImage, {
        rotate: -27,
        translateY: "235%",
        opacity: 0,
        ease: "none",
      })
      .to(this.bottomPanel, {
        opacity: 1,
        ease: "none",
      })
      .to(this.bottomImage, {
        opacity: 0.5,
        ease: "none",
      });

  //   gsap
  //     .timeline({
  //       scrollTrigger: {
  //         trigger: this.bottomPanel,
  //         scrub: 1,
  //         start: "top 150px",
  //         end: "+=400",
  //         pin: true,
  //         pinSpacing: true,
  //       },
  //     })
  //     .to(this.blockHeading, { opacity: 1, scale: 1, ease: "none" }, 0)
  //     .to(this.blockText, { opacity: 1, scale: 1, ease: "none" }, 0)
  //     .to(this.blockBtn, { opacity: 1, scale: 1, ease: "none" }, 0);
    
  }
}

customElements.define("inigma-anim", InigmaAnim);


class InigmaLock extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".inigma_lock_media img");

    this.init();
  }

  init() {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this,
          scrub: 1,
          start: "top 150px",
          end: "+=100",
          pin: true,
          pinSpacing: true,
        },
      })
      .to(this.image, {
        scale: 1,
        ease: "none",
      });
  }
}

// customElements.define("inigma-lock", InigmaLock);
